import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

window.dataLayer = window.dataLayer || [];

function gtag() {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

Vue.use(VueRouter);

const routes = [
  {
    name: 'Homepage',
    path: '/',
    component: Home,
  },
  {
    name: 'Productfinder',
    path: '/finder',
    component: () => import('../views/Finder.vue'),
  },
  {
    name: 'Product Group',
    path: '/products/:id',
    component: () => import('../views/Products.vue'),
  },
  {
    name: 'Product Overview',
    path: '/products',
    component: () => import('../views/ProductOverview.vue'),
  },
  {
    path: '*',
    component: Home,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
});

router.afterEach((to) => {
  if (Array.isArray(window.dataLayer)) {
    gtag('config', 'UA-29002090-5', {
      page_title: to.name,
      page_path: to.path,
      anonymize_ip: true,
    });
  }
});

export default router;
